/**
 * Enum for localStorage keys used throughout the application
 * Using an enum helps prevent typos and provides a central place to manage keys
 */
export enum EStorageKeys {
  AUTH0_USER = 'auth0User',
  CURRENT_USER = 'userData',
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  ID_TOKEN = 'id_token',
  ADMIN_DASHBOARD_FILTERS = 'admin_dashboard_filters',
  GYM_DASHBOARD_FILTERS = 'gym_dashboard_filters',
}
